module.exports = __webpack_public_path__ + "static/img/High Transparent Fumed Silicone Rubber.a49bfed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/High Transparent Fumed Silicone Rubber.jpg
// module id = FpKB
// module chunks = 1